import React from 'react'
import PropTypes from 'prop-types'
import { Label, Table, Loader } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { CRUDIndex } from '../CRUD'
import { EditDeleteButtonContainer } from '../../containers'

const ServicoInstalacao = (props) => (
  <CRUDIndex noTitle padded={false}
    onRedirectToNew={props.onRedirectToNew}
    onExportToCSV={props.onExportToCSV}
    filterText={props.filterText}
    handleFilter={props.handleFilter}
  >
    <Table sortable celled striped selectable>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell textAlign='center' width={1}
            onClick={props.handleSort('id')}
            sorted={props.handleSorted('id')}>#</Table.HeaderCell>
          <Table.HeaderCell width={2}
            onClick={props.handleSort('servico.nome')}
            sorted={props.handleSorted('servico.nome')}>Serviço</Table.HeaderCell>
          <Table.HeaderCell width={2}
            onClick={props.handleSort('executado_em')}
            sorted={props.handleSorted('executado_em')}>Executado Em</Table.HeaderCell>
          <Table.HeaderCell
            onClick={props.handleSort('descricao')}
            sorted={props.handleSorted('descricao')}>Descrição</Table.HeaderCell>
          <Table.HeaderCell width={1}></Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {props.isLoading && (
          <Table.Row>
            <Table.Cell colSpan='7'>
              <Loader active={props.isLoading} inline='centered' />
            </Table.Cell>
          </Table.Row>
        )}
        {props.multipleServicoInstalacao.valueSeq().map((servicoInstalacao, index) => (
          <Table.Row key={index}>
            <Table.Cell textAlign='center'>
              <Label as={Link} to={`/instalacoes/${servicoInstalacao.getIn(['instalacao', 'id'])}/servicos/${servicoInstalacao.get('id')}`}>
                {servicoInstalacao.get('id')}
              </Label>
            </Table.Cell>
            <Table.Cell>
              <Label as={Link} to={`/servicos/${servicoInstalacao.getIn(['servico', 'id'])}`}>
                {servicoInstalacao.getIn(['servico', 'nome'])}
              </Label>
            </Table.Cell>
            <Table.Cell>{servicoInstalacao.get('executado_em')}</Table.Cell>
            <Table.Cell>{servicoInstalacao.get('descricao')}</Table.Cell>
            <Table.Cell>
              <EditDeleteButtonContainer
                onEditResource={() => props.onEditResource(props.instalacao.id, servicoInstalacao.get('id'))}
                onDeleteResource={() => props.onDeleteResource(servicoInstalacao.get('id'))} />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  </CRUDIndex>
)

ServicoInstalacao.propTypes = {
  instalacao: PropTypes.object,
  multipleServicoInstalacao: PropTypes.object,
  onRedirectToNew: PropTypes.func,
  onEditResource: PropTypes.func,
  onDeleteResource: PropTypes.func,
  handleSort: PropTypes.func,
  handleSorted: PropTypes.func,
  filterText: PropTypes.string,
  handleFilter: PropTypes.func,
  onExportToCSV: PropTypes.func,
  isLoading: PropTypes.bool,
}

export default ServicoInstalacao
